import { faCloud, faCloudRain, faSnowflake, faSun } from '@fortawesome/free-solid-svg-icons';

export const FormatDay = (day = 0) => {
  if (day < 10) day = '0' + day;
  return day;
};

export const GetDayofWeek = (day = 0) => {
  let DayofWeek = '';
  switch (day) {
    case 0:
      DayofWeek = 'Domingo';
      break;
    case 1:
      DayofWeek = 'Segunda';
      break;
    case 2:
      DayofWeek = 'Terça';
      break;
    case 3:
      DayofWeek = 'Quarta';
      break;
    case 4:
      DayofWeek = 'Quinta';
      break;
    case 5:
      DayofWeek = 'Sexta';
      break;
    case 6:
      DayofWeek = 'Sábado';
      break;
    default:
      DayofWeek = '';
      break;
  }
  return DayofWeek;
};

export const GetMonthName = (month = 0) => {
  let MonthName = '';
  switch (month) {
    case 0:
      MonthName = 'Janeiro';
      break;
    case 1:
      MonthName = 'Fevereiro';
      break;
    case 2:
      MonthName = 'Março';
      break;
    case 3:
      MonthName = 'Abril';
      break;
    case 4:
      MonthName = 'Maio';
      break;
    case 5:
      MonthName = 'Junho';
      break;
    case 6:
      MonthName = 'Julho';
      break;
    case 7:
      MonthName = 'Agosto';
      break;
    case 8:
      MonthName = 'Setembro';
      break;
    case 9:
      MonthName = 'Outubro';
      break;
    case 10:
      MonthName = 'Novembro';
      break;
    case 11:
      MonthName = 'Dezembro';
      break;
    default:
      MonthName = '';
      break;
  }
  return MonthName;
};

export const GreetingsMessage = (time) => {
  if (time) {
    if (time.match(/AM/g) || time.match(/PM/gi)) {
      const parsedTime = parseInt(time.slice(0, -9));
      if (parsedTime >= 0 && parsedTime < 12 && time.match(/AM/gi)) return 'Bom Dia';
      if (parsedTime >= 1 && parsedTime < 6 && time.match(/PM/gi)) return 'Boa Tarde';
      if (parsedTime >= 6 && time.match(/PM/gi)) return 'Boa Noite';
    } else {
      const parsedTime = time.slice(0, -6);
      if (parsedTime >= 0 && parsedTime < 12) return 'Bom Dia';
      if (parsedTime >= 12 && parsedTime < 18) return 'Boa Tarde';
      if (parsedTime >= 18) return 'Boa Noite';
    }
  }
  return;
};

export const getWeatherIcon = (weather) => {
  switch (weather) {
    case 'Clear':
      return faSun;
    case 'Thunderstorm' || 'Drizzle' || 'Rain':
      return faCloudRain;
    case 'Snow':
      return faSnowflake;
    case 'Mist' || 'Smoke' || 'Haze' || 'Dust' || 'Fog' || 'Sand' || 'Dust' || 'Ash' || 'Squall' || 'Tornado':
      return faCloud;
    default:
      return faSun;
  }
};
